import { Injectable, inject, DestroyRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, Store } from '@ngxs/store';
import { LookupService } from '@services/lookup.service';
import { TsFilterUtilsService } from '@services/ts-filter-utils.service';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { AccountService } from '@core/services';
import { TsSnackbarService } from 'tsui';
import { LayoutService } from 'app/layout/layout.service';
import { DropdownService } from '@services/dropdown.service';
import { AccountState } from '@state/account/state';
import { ConfirmService } from '@shared/components/widgets/dialog/confirm/confirm.service';
import shortUniqueId from 'short-unique-id';
import { ConfirmationDialogService } from '@shared/components/widgets/dialog/confirmation/confirmation-dialog.service';
import { NewPermission } from '@core/enums';
import { UserState } from '@state/user/state';

@Injectable()
export abstract class TsComponent {
  protected readonly router = inject(Router);
  protected readonly activatedRoute = inject(ActivatedRoute);
  protected readonly store = inject(Store);
  protected readonly actions$ = inject(Actions);
  protected readonly destroyRef = inject(DestroyRef);
  readonly lookupService = inject(LookupService);
  protected readonly tsFilterUtilsService = inject(TsFilterUtilsService);
  protected readonly matDialog = inject(MatLegacyDialog);
  protected readonly accountService = inject(AccountService); // I don't like this, but it's a quick fix for now
  protected readonly tsSnackbarService = inject(TsSnackbarService);
  protected readonly layoutService = inject(LayoutService);
  protected readonly confirmationDialogService = inject(ConfirmationDialogService);
  protected readonly dropdownService = inject(DropdownService); // this should have its own state (not straight-forward solution)

  protected readonly changeDetectorRef = inject(ChangeDetectorRef);
  protected readonly account = this.store.selectSnapshot(AccountState.getAccount);

  private uniqueId = new shortUniqueId({ length: 6, dictionary: 'number' });

  public rndId = (): string => this.uniqueId.rnd().toLowerCase();

  can(permission: NewPermission): boolean {
    return this.store.selectSnapshot(UserState.hasPermission(permission));
  }
}
